import { render, staticRenderFns } from "./TuitionBillSummaryChart.vue?vue&type=template&id=513e7ba4&scoped=true"
import script from "./TuitionBillSummaryChart.vue?vue&type=script&lang=js"
export * from "./TuitionBillSummaryChart.vue?vue&type=script&lang=js"
import style0 from "./TuitionBillSummaryChart.vue?vue&type=style&index=0&id=513e7ba4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513e7ba4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('513e7ba4')) {
      api.createRecord('513e7ba4', component.options)
    } else {
      api.reload('513e7ba4', component.options)
    }
    module.hot.accept("./TuitionBillSummaryChart.vue?vue&type=template&id=513e7ba4&scoped=true", function () {
      api.rerender('513e7ba4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/component/TuitionBillSummaryChart.vue"
export default component.exports